const cloneDeep = require('lodash/clonedeep');
import * as api_request from '../../../shared/network/request_extensions';
import * as global_constants from '../../../global_constants';

export const get_insurance_class_has_active_providers = (token, insurance_class_id) => {
    let url = `${global_constants.base_end_points}${global_constants.end_points.insurance.has_active_providers(insurance_class_id)}`;
    return api_request.get_config_request(url, token, null);
}